<div *ngIf="null !== amount">
  <ul class="mobile-overflow uk-accordion" uk-accordion>
    <li class="uk-open">
      <p class="uk-accordion-title uk-heading-divider" href="#" [title]="'Pozostałe informacje służące diagnostyce'">{{name}}</p>
      <div class="uk-accordion-content">
        <div class="uk-grid">
          <div class="uk-width-1-6">
            <label>Suma</label>
            <input class="uk-input" disabled [value]="amount.summary">
          </div>

          <div class="uk-width-1-6">
            <label>Kurs waluty kraju odbiorcy</label>
            <input class="uk-input" disabled [value]="amount.specific_exchange_rate">
          </div>
          <div class="uk-width-1-6">
            <label>Waluta kraju odbiorcy</label>
            <input class="uk-input" disabled [value]="currency">
          </div>
          <div class="uk-width-1-2"></div>
          <div class="uk-width-1-2">
            <div class="uk-grid">
              <div class="uk-width-1-4">
                <label>Kwota bazowa</label>
                <input class="uk-input" disabled [value]="amount.base">
              </div>
              <div class="uk-width-1-4">
                <label>Pobranie</label>
                <input class="uk-input" disabled [value]="amount.cod">
              </div>
              <div class="uk-width-1-4">
                <label>Zadekl. wartość</label>
                <input class="uk-input" disabled [value]="amount.insurance">
              </div>
              <div class="uk-width-1-4">
                <label>Overweight</label>
                <input class="uk-input" disabled [value]="amount.overweight">
              </div>
            </div>
          </div>
          <div class="uk-width-1-2">
            <div class="uk-grid">
              <div class="uk-width-1-4">
                <label>Oversize</label>
                <input class="uk-input" disabled [value]="amount.oversize">
              </div>
              <div class="uk-width-1-4">
                <label>Wielopak</label>
                <input class="uk-input" disabled [value]="amount.multi_pack">
              </div>
              <div class="uk-width-1-4">
                <label>Nieodbiór</label>
                <input class="uk-input" disabled [value]="amount.unclaimed">
              </div>
              <div class="uk-width-1-4">
                <label>Odbiór od klienta</label>
                <input class="uk-input" disabled [value]="amount.collect_from_client">
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
